import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import ClientHeader from '../components/content-panes/client-header/clientHeader';
import ClientFooter from '../components/clients/client-dashboard/client-footer/client-footer';
import ClientBreadCrumb from '../components/content-panes/client-breadcrumbs/clientBreadcrumb';
import './styles/clientContainer.css';
import { AddClientUserDialog } from '../components/clients/add-user/addUserDialog';
import { useState } from 'react';
import { ClientCandidateInformation } from '../components/clients/candidate-information/clientCandidateInformation';
import ClientCandidateSearch from '../components/clients/client-candidate-search/clientCandidateSearch';
import CandidateSearch from '../components/clients/client-dashboard/candidate-searchresults/candidatesearch';
import { ClientDashboard } from '../components/clients/client-dashboard/client-dashboard';
import Policy from '../components/homepage/resources-policy/policy';
import Resourcesblog from '../components/homepage/resources-blog/blog';
import BlogDetails from '../components/homepage/resources-blogdetails/blogdetails';
import AboutUs from '../components/homepage/resources-about-us/about-us';
import ContactUs from '../components/homepage/resources-contact-us/contact-us';
import Pricingprelogin from '../components/homepage/pricingprelogin/pricingprelogin';
import Navbarfaq from '../components/homepage/resources-FAQ/faq';
import ContactSales from '../components/homepage/contact-sales/contact-sales';
import { ClientUserProfile } from '../components/clients/clientUserProfile/clientUserProfile';
import { UserProvider } from '../components/clients/userContext/userContext';
import NotificationDetails from '../components/notificationDetails/notificationDetails';
import { CandidateProfile } from '../components/candidates/candidateProfile/candidateProfile';
import CandidateResetPassword from '../components/candidates/candidateResetPassword/passwordReset';
import CuratedShortlistedSearch from '../components/clients/curatedShortlistedSearch/curatedShortlistedSearch';
import ClientUsers from '../components/clients/clientUsers/clientUsers';
import { decodeJWT } from '../services/candidateService';
import ClientJobListings from '../components/clients/job-postings/clientJobListings';

export const ClientContainer = () => {
  const [showUserDialog, setShowUserDialog] = useState(false);
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const role = decoded.roles;
  let location;
  try {
    location = useLocation();
  } catch (e) {
    return (
      <BrowserRouter>
        <ClientContainer />
      </BrowserRouter>
    );
  }



  return (
    <>
      <AddClientUserDialog show={showUserDialog} setShow={setShowUserDialog} />
      <UserProvider>

        <ClientHeader />
        <div className="fluid-container">
          <Row>
            <Col className="contentPane">

              <Routes>
                <Route path="/client/dashboard" element={<ClientDashboard />} />
                <Route path="/client/client-user-profile" element={<ClientUserProfile />} />
                <Route path="/client/candidate-information" element={<ClientCandidateInformation />} />
                {/* <Route path="/client/search-candidate" element={<ClientCandidateSearch />} /> */}
                <Route path="/client/search-candidate" element={<CuratedShortlistedSearch />} />
                {/* <Route path="/client/candidate-reports" element={<ClientCandidateReport />} /> */}
                {role !== 'CLIENT_USER' && (
                  <Route path="/client/users" element={<ClientUsers />} />
                )}
                <Route path="/client/candidate-search-result" element={<CandidateSearch />} />
                <Route path="/" element={<Navigate to="/client/dashboard" />} />
                {/* <Route path='/notification-details' element={<NotificationDetails />} /> */}
                <Route path="/client/password-reset" element={<CandidateResetPassword />} />
                <Route path='/candidate/profile' element={<CandidateProfile />} />
                <Route path="/client/job-postings" element={<ClientJobListings />} />
                <Route path="/pricing-prelogin" element={<Pricingprelogin />} />
                <Route path='/contact-sales' element={<ContactSales />} />
                <Route path="/resources-blog" element={<Resourcesblog />} />
                <Route path="/navbar-faq" element={<Navbarfaq />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/blogdetails" element={<BlogDetails />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/contact-us" element={<ContactUs />} />
              </Routes>

            </Col>
          </Row>
        </div>
      </UserProvider>

      <br />
      <ClientFooter />
    </>
  );
};
